var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayout } from "@/hooks/layout";
import widgetsDictionary from "../widgetsDictionary";
import { Slot } from "@/utils/types/layout";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "@/hooks/store";
import { setFieldState, setFrozenFieldState, } from "@/store/fieldSlice";
import { ElementPageSelector } from "@/components/dev/selector";
import { setElementCountPerPage } from "@/store/filterSlice";
import { setWidgetDisplay } from "@/store/layoutSlice";
import "./managerField.css";
import ColumnManager from "./columnManager";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faSlash, faThumbtack, } from "@fortawesome/pro-solid-svg-icons";
import { faGripLines } from "@fortawesome/pro-regular-svg-icons";
export default function ManagerField(_a) {
    var _this = this;
    var _b, _c, _d;
    var widget = _a.widget;
    var modules = useParams();
    var layout = useLayout();
    var t = useTranslation(["common"]).t;
    var module = ((_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.module) || modules.module;
    var totalCount = (_c = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _c === void 0 ? void 0 : _c.count;
    var elementStateCountPerPage = useAppSelector(function (state) { return state.filter.element_per_page; });
    var elementCountPerPage = (widget === null || widget === void 0 ? void 0 : widget.payload.elementPerPage) || elementStateCountPerPage;
    var tempState = useAppSelector(function (state) { var _a, _b; return (_b = (_a = state.field) === null || _a === void 0 ? void 0 : _a.freeze_rows) !== null && _b !== void 0 ? _b : []; });
    var defaultFreezeRows = ((_d = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _d === void 0 ? void 0 : _d.module) === tempState[0] && tempState[1] !== undefined
        ? tempState[1].toString()
        : "0";
    var valueFieldState = useAppSelector(function (state) { return state.field.fields_state_list; });
    var frozen_columns_state = useAppSelector(function (state) { return state.field.frozen_fields; });
    var _e = useState(valueFieldState), fieldsAvailable = _e[0], setFieldsAvailable = _e[1];
    var _f = useState(frozen_columns_state), freezedColumn = _f[0], setFreezedColumn = _f[1];
    var freezeColumnHandler = function (item) { return __awaiter(_this, void 0, void 0, function () {
        var index_first_column, index_last_column_selected, list_freezed_column, list_freezed_column_1;
        return __generator(this, function (_a) {
            index_first_column = 0;
            index_last_column_selected = (fieldsAvailable === null || fieldsAvailable === void 0 ? void 0 : fieldsAvailable.findIndex(function (element) { return element.name === item.name; })) || 0;
            list_freezed_column = fieldsAvailable === null || fieldsAvailable === void 0 ? void 0 : fieldsAvailable.slice(index_first_column, index_last_column_selected + 1);
            setFreezedColumn(list_freezed_column);
            if ((freezedColumn === null || freezedColumn === void 0 ? void 0 : freezedColumn.length) > 0 &&
                freezedColumn[freezedColumn.length - 1].name === item.name) {
                list_freezed_column_1 = fieldsAvailable === null || fieldsAvailable === void 0 ? void 0 : fieldsAvailable.slice(index_first_column, index_last_column_selected);
                setFreezedColumn(list_freezed_column_1);
            }
            return [2 /*return*/];
        });
    }); };
    var changeVisibility = function (array, item) {
        return (array &&
            array.map(function (f) {
                if (f.name === item.name) {
                    return __assign(__assign({}, f), { default: !f.default });
                }
                return f;
            }));
    };
    var onDragEnd = function (result) {
        // Your logic for handling drag end event
        // For example, updating the order of items
        // result will contain information about the drag and drop operation
        var destination = result.destination, source = result.source;
        // If there's no destination or if the item was dropped in the same place, do nothing
        if (!destination || destination.index === source.index) {
            return;
        }
        // Reorder the items array based on the drag-and-drop result
        var updatedItems = __spreadArray([], (fieldsAvailable || []), true);
        var draggedItem = updatedItems.splice(source.index, 1)[0];
        updatedItems.splice(destination.index, 0, draggedItem);
        // Update state with the reordered items
        setFieldsAvailable(updatedItems);
    };
    var handleVisibility = function (item) {
        setFieldsAvailable(changeVisibility(fieldsAvailable, item));
        setFreezedColumn(changeVisibility(freezedColumn, item));
    };
    var dispatch = useAppDispatch();
    var onClickUpdate = function () {
        dispatch(setWidgetDisplay(true));
        dispatch(setFieldState(fieldsAvailable));
        dispatch(setFrozenFieldState(freezedColumn));
        layout.removeWidgetById({
            id: widget.id,
            slot: [Slot.DRAWER_SOUTH],
            type: "widget/managerField",
        });
    };
    var defaultNumbers = [
        { value: "5", label: "5" },
        { value: "10", label: "10" },
        { value: "25", label: "25" },
        { value: "50", label: "50" },
        { value: "100", label: "100" },
    ];
    var _g = useState(elementCountPerPage === "infini" ? "" : elementCountPerPage), localValue = _g[0], setLocalValue = _g[1];
    useEffect(function () {
        setLocalValue(elementCountPerPage);
        // Si elementCountPerPage est infini, on change aussi le displayMode
        if (elementCountPerPage === "infini") {
            setDisplayMode("infinite");
            setLocalValue(""); // On vide le select si infinite
        }
        else {
            setDisplayMode("navigation");
            setLocalValue(elementCountPerPage);
        }
    }, [elementCountPerPage]);
    var displayModes = [
        { value: "navigation", label: t("app.LBL_MANAGERFIELD_NAVIGATION") },
        { value: "infinite", label: t("app.LBL_MANAGERFIELD_INFINITE_SCROLL") },
    ];
    var _h = useState("navigation"), displayMode = _h[0], setDisplayMode = _h[1];
    var handleDisplayModeChange = function (e) {
        var value = e.value;
        setDisplayMode(value);
        if (value === "infinite") {
            dispatch(setElementCountPerPage("infini"));
        }
    };
    // Gestion verouillage ligne
    var rowsId = Array.from({
        length: elementCountPerPage === t("app.LBL_INFINITY")
            ? 30
            : elementCountPerPage,
    }, function (_, index) { return index + 1; });
    var rowsObject = [];
    rowsId.map(function (i) {
        var temp = {};
        temp.value = i - 1;
        temp.label = i - 1;
        rowsObject.push(temp);
    });
    var _j = useState(false), closing = _j[0], setClosing = _j[1];
    //Gestion de defaultNumbers par rapport aux nombre total de l'enregistrement
    var ICON_DESCRIPTIONS = [
        {
            icon: faGripLines,
            color: "text-gray-600",
            text: t("app.LBL_ICON_DRAG_COLUMN"),
        },
        {
            icon: faEye,
            color: "text-[rgb(var(--color-blue-700))]",
            text: t("app.LBL_ICON_VISIBLE_COLUMN"),
        },
        {
            icon: faEyeSlash,
            color: "text-[rgb(var(--color-blue-700))]",
            text: t("app.LBL_ICON_HIDDEN_COLUMN"),
        },
        {
            icon: faThumbtack,
            color: "text-[rgb(var(--color-blue-700))]",
            text: t("app.LBL_ICON_LOCKED_COLUMN"),
        },
        {
            icon: faThumbtack,
            color: "text-[rgb(var(--color-blue-700))]",
            text: t("app.LBL_ICON_UNLOCKED_COLUMN"),
            lock: true,
        },
    ];
    return (_jsxs("div", __assign({ className: " bg-[var(--colors-body-bg)] flex flex-col max-h-screen ".concat(closing ? "slide-out" : "") }, { children: [_jsx("div", __assign({ className: "flex-1 overflow-auto p-5" }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 gap-6 lg:grid-cols-3" }, { children: [_jsxs("div", __assign({ className: "bg-[var(--colors-bg-default)] rounded-xl shadow-xl p-6 flex flex-col" }, { children: [_jsx("p", __assign({ className: "mb-4 text-center text-sm font-semibold uppercase text-[var(--colors-text-primary)]" }, { children: t("app.LBL_MANAGERFIELD_PAGE") })), _jsx(ElementPageSelector, { label: t("app.LBL_NAVIGATION_OPTIONS"), listValues: displayModes, currentValue: displayMode, onChangeValue: handleDisplayModeChange }), displayMode === "navigation" && (_jsx(ElementPageSelector, { label: t("app.LBL_MANAGERFIELD_TOTAL_LINE"), listValues: defaultNumbers, currentValue: "".concat(localValue), onChangeValue: function (e) {
                                        setLocalValue(e.value);
                                        dispatch(setElementCountPerPage(e.value));
                                    } }))] })), _jsx("div", __assign({ className: "lg:col-span-2 bg-[var(--colors-bg-default)] rounded-xl shadow-xl p-6" }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 md:grid-cols-2 gap-6 h-full" }, { children: [_jsxs("div", __assign({ className: "flex flex-col md:border-r border-gray-200 pr-6" }, { children: [_jsx("p", __assign({ className: "mb-4 text-center text-sm font-semibold uppercase text-[var(--colors-text-primary)]" }, { children: t("app.LBL_COLUMNS_CONFIGURATION") })), _jsx(ColumnManager, { data: fieldsAvailable, module: module, onDragEnd: onDragEnd, onClickVisibility: handleVisibility, onClickFreeze: freezeColumnHandler, frozenColumnList: freezedColumn })] })), _jsx("div", __assign({ className: "p-6 flex flex-col h-full text-[var(--colors-text-primary)]" }, { children: _jsx("div", __assign({ className: "mt-auto space-y-3" }, { children: ICON_DESCRIPTIONS.map(function (_a, index) {
                                                var icon = _a.icon, color = _a.color, text = _a.text, lock = _a.lock;
                                                return (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [_jsxs("div", __assign({ className: "relative w-4 h-4" }, { children: [_jsx(FontAwesomeIcon, { icon: icon, size: "xs", className: "absolute inset-0 w-4 h-4 ".concat(color, " ") }), lock && (_jsx(FontAwesomeIcon, { icon: faSlash, size: "xs", className: "absolute inset-0 w-4 h-4 text-[rgb(var(--color-blue-700))] scale-45" }))] })), _jsx("span", __assign({ className: "text-sm" }, { children: text }))] }), index));
                                            }) })) }))] })) }))] })) })), _jsxs("div", __assign({ className: "sticky bottom-0 grid grid-cols-2 text-[rgb(var(--color-blue-500))] justify-items-center border-t-[1px] p-2" }, { children: [_jsx("button", __assign({ className: "button danger", onClick: function () {
                            dispatch(setWidgetDisplay(true));
                            setClosing(true);
                            setTimeout(function () {
                                layout.removeWidgetById({
                                    id: widget.id,
                                    slot: [Slot.DRAWER_SOUTH],
                                    type: "widget/managerField",
                                });
                            }, 150);
                        } }, { children: t("app.LBL_CLOSE_DASHLETS") })), _jsx("button", __assign({ className: "button primary", onClick: onClickUpdate }, { children: t("app.LBL_UPDATE") }))] }))] })));
}
widgetsDictionary.register("widget/managerField", {
    name: "Widget manager display field",
    display: ManagerField,
    selectable: false,
});
